<template>
  <v-app>
    <v-main>
      <title-page title="احراز هویت" :sheetStyle="['mobile-container', 'border']" class="mb-20">
        <div class="mobile-container">
          <div class="subtitle1-regular medium-emp pa-4 mr-md-10">
            مشخصات خود را وارد کنید.
          </div>
          <keep-alive>
            <!-- Legal or individual component trigers here -->
            <component
              v-if="type"
              :is="type"
              :auth="auth"
              @handle-place-dialog="handleCityDialog"
              @handle-validate="validationUpdate"
              :selected-city="selectedCity"
            ></component>
          </keep-alive>
        </div>

        <template #navbar>
          <v-row class="px-1" no-gutters>
            <v-col cols="6" class="pl-2">
              <v-btn
                to="/CompleteAuthInfo"
                outlined
                class="
                  white
                  border-outline
                  d-flex
                  justify-center
                  align-center
                  logistic--text
                  force-color
                  rounded
                  w-100
                  py-6
                "
              >
                قبلی
              </v-btn>
            </v-col>
            <v-col cols="6" class="pr-2">
              <v-btn
                block
                elevation="0"
                :loading="loading"
                :disabled="!formValidation"
                class="logistic-color white--text py-6"
                @click.prevent="submit()"
              >
                بعدی
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </title-page>
      <city-select-list
        :visible="cityDialog"
        :current-value="selectedCity"
        @handle-place-dialog="handleCityDialog"
        title=""
      ></city-select-list>

      <v-snackbar v-model="loading" width="100%" timeout="-1">
        <loading class="light" />
        <p class="text-center mb-0">لطفاً منتظر بمانید</p>
      </v-snackbar>
      
    </v-main>
  </v-app>
</template>

<script>
import TitlePage from "../components/Layouts/TitlePage.vue";
import Individual from "../components/Auth/Individual.vue";
import Legal from "../components/Auth/Legal.vue";
import CitySelectList from "../components/CitySelectList.vue";

export default {
  name: "AuthenticationForm",
  components: { TitlePage, Individual, Legal, CitySelectList },
  data() {
    return {
      cityDialog: false,
      selectedCity: {
        state: null,
        city: null,
      },
      formValidation: false,
      loading: false,
      auth: {},
    };
  },
  computed: {
    type() {
      return this.$route.params.type;
    },
  },
  methods: {
    async submit() {
      this.loading = true;
      let params = new FormData();
      const auth = this.auth;
      const type = this.type.toLowerCase();

      switch (type) {
        case "legal":
          params.append("company_name", auth.companyName);
          params.append("national_id", auth.national_id);
          params.append("company_landline", auth.company_landline);
          params.append("postal_code ", auth.postal_code);
          params.append("newspaper_image", auth.newspaper_image?.file);
          params.append("company_logo_image", auth.logo_image?.file);
          break;

        case "individual":
          params.append("national_code", auth.national_code);
          params.append("nationalCard_image_with_user", auth.selfie?.file);
          break;
      }

      params.append("authentication_type", type);
      params.append("company_agent_name", auth.name);
      params.append("company_address", auth.address);
      params.append("city", auth.city);
      params.append("ostan", auth.province);
      params.append("nationalCard_image", auth.nationalCard?.file);

      const user = this.$parseSDK.User.current();
      const sessionToken = user.get("sessionToken");
      const headers = {
        "X-Parse-Session-Token": sessionToken,
        "X-Parse-Application-Id": this.$store.state.PARSE_APP_ID,
      };
      const uri = "/authentication-company";
      const res = await this.axios
        .post(uri, params, { headers })
        .catch((err) => this.handleAuthErr(err));

      if (res) {
        this.$router.push("/panel/WaitingForAuth").catch(() => true);
        this.$utils.showMessage(
          "درخواست شما ثبت شد. لطفا منتظر تایید کارشناسان جاده بمانید",
          {
            type: "success",
          }
        );
        this.$logAnalyticsEvent("register");
      }

      this.loading = false;
    },

    handleAuthErr(error) {
      const code = error.response.data?.message;
      const commonErr = this.$utils.handleErrorIfKnown(code);
      if (commonErr) return;

      let msg = "درخواست شما با خطا مواجه شد";

      if (code === 4012) {
        msg = "شما قبلا احراز هویت شده اید";
      } else if (code === 2004) {
        msg = "اطلاعات وارد شده ناقص است";
      }

      this.$utils.showMessage(msg, {
        type: "error",
      });
    },
    handleCityDialog(op, data) {
      switch (op) {
        case "close":
          this.cityDialog = false;

          if (!data) {
            this.selectedCity = {
              state: null,
              city: null,
            };
            this.auth.city = null;
            this.auth.province = null;
            return;
          }

          this.auth.city = data.city;
          this.auth.province = data.state;
          this.selectedCity = data;
          break;

        case "open":
          this.cityDialog = true;
          break;
      }
    },
    validationUpdate(val) {
      this.formValidation = val;
    },
  },
};
</script>

<style scoped>
.min-h-scroll {
  height: calc(100vh - 149px);
  overflow-y: scroll;
}
.mb-20 {
  padding-bottom: 62px;
}
.border-outline {
  border: none;
  outline: 0.5px solid rgba(0, 0, 0, 0.12) !important;
}
.light{
  filter: grayscale(100%) brightness(1000%);
}
</style>
